var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2543 6.56377L14.2855 5.53252C14.6914 5.12654 15.1733 4.80449 15.7036 4.58477C16.234 4.36504 16.8024 4.25195 17.3765 4.25195C17.9505 4.25195 18.519 4.36504 19.0493 4.58477C19.5797 4.80449 20.0615 5.12654 20.4674 5.53252C20.8734 5.93838 21.1954 6.42025 21.4152 6.9506C21.6349 7.48095 21.748 8.04939 21.748 8.62346C21.748 9.19752 21.6349 9.76596 21.4152 10.2963C21.1954 10.8267 20.8734 11.3085 20.4674 11.7144L18.1818 14L17.2124 14.9694C16.8061 15.3758 16.3236 15.6981 15.7926 15.9178C15.2615 16.1376 14.6924 16.2505 14.1177 16.25C13.543 16.2496 12.974 16.1359 12.4433 15.9153C11.9126 15.6948 11.4306 15.3717 11.0249 14.9647C10.6049 14.5449 10.2752 14.0437 10.056 13.4919C9.83671 12.94 9.73256 12.3492 9.74991 11.7556",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7457 18.4362L9.71448 19.4674C9.30814 19.8738 8.82565 20.1961 8.29463 20.4159C7.7636 20.6356 7.19446 20.7485 6.61976 20.7481C6.04506 20.7477 5.47609 20.6339 4.94539 20.4134C4.4147 20.1928 3.9327 19.8698 3.52698 19.4628C2.70947 18.6424 2.2509 17.5311 2.25195 16.373C2.25301 15.2148 2.7136 14.1044 3.5326 13.2856L6.7876 10.0306C7.19347 9.62458 7.67534 9.30253 8.20569 9.08281C8.73604 8.86309 9.30448 8.75 9.87854 8.75C10.4526 8.75 11.021 8.86309 11.5514 9.08281C12.0817 9.30253 12.5636 9.62458 12.9695 10.0306C13.3912 10.4503 13.7224 10.9521 13.9426 11.5048C14.1629 12.0576 14.2675 12.6496 14.2501 13.2443",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copy_link_icon.dc5f2e8074946a591824b490cf641471.svg";
export { ForwardRef as ReactComponent };